import { createEl } from "@/client/utils/createEl";
import { checkbox, type CheckboxVariants } from "./checkbox.css";

export interface CheckboxOptions extends NonNullable<CheckboxVariants> {
    checked?: boolean;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
    ariaLabel?: string;
}

export interface CheckboxElement extends HTMLInputElement {
    setChecked: (checked: boolean) => void;
}

export const createCheckbox = (
    options: CheckboxOptions,
    init?: (el: CheckboxElement) => void,
): CheckboxElement => {
    const className = checkbox({
        theme: options.theme,
    });

    const el = createEl("input", className, [], (el) => {
        el.type = "checkbox";
        el.checked = options.checked ?? false;
        el.disabled = options.disabled ?? false;
        if (options.ariaLabel !== undefined) {
            el.setAttribute("aria-label", options.ariaLabel);
        }
        if (options.onChange !== undefined) {
            el.addEventListener("change", () => {
                options.onChange?.(el.checked);
            });
        }
    }) as CheckboxElement;

    el.setChecked = (checked: boolean) => {
        el.checked = checked;
    };

    init?.(el);

    return el;
};
